const emailAddressBookActions = {
  REQUEST_EMAIL_ADDRESS_BOOK: 'REQUEST_EMAIL_ADDRESS_BOOK',
  RECEIVE_EMAIL_ADDRESS_BOOK: 'RECEIVE_EMAIL_ADDRESS_BOOK',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  REQUEST_GROUPS: 'REQUEST_GROUPS',
  RECEIVE_GROUPS: 'RECEIVE_GROUPS',
  GROUP_SERVER_ERROR_OCURED: 'GROUP_SERVER_ERROR_OCURED',
  GROUP_CLEAR_ERRORS: 'GROUP_CLEAR_ERRORS',
  SEARCH_KEYWORD: 'SEARCH_KEYWORD',
  SORT_ADDRESS_BOOK: 'SORT_ADDRESS_BOOK'
};
 export default emailAddressBookActions;


// WEBPACK FOOTER //
// src/routes/EmailAddressBook/actions/actiontypes.js